import { render } from "./scoreSuccess.vue?vue&type=template&id=267ef2e7&scoped=true"
import script from "./scoreSuccess.vue?vue&type=script&lang=js"
export * from "./scoreSuccess.vue?vue&type=script&lang=js"

import "./scoreSuccess.vue?vue&type=style&index=0&id=267ef2e7&scoped=true&lang=css"

import exportComponent from "D:\\AestProject\\EducationOrg\\qianhedu-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-267ef2e7"]])

export default __exports__